import React from 'react';

import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';

import SchoolDetails from './SchoolDetails';
import WorkDetails from './WorkDetails';

import * as validator from 'helpers/Validator';

class CurrentOccupation extends React.Component {
  render() {
    const { isStudent, hasWorkExperience } = this.props;

    return (
      <div className="row">
        <h5 style={{ textAlign: 'center', marginBottom: '25px' }}>
          Does the applicant have work experience?
        </h5>
        <BooleanRadioButtons
          name="has_work_experience"
          style={{ width: '187px', margin: 'auto' }}
          validate={[validator.required]}
        />

        {hasWorkExperience && <WorkDetails {...this.props} />}

        <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>Is the applicant a student?</h5>
        <BooleanRadioButtons
          name="is_student"
          style={{ width: '187px', margin: 'auto' }}
          validate={[validator.required]}
        />

        {isStudent && <SchoolDetails />}
      </div>
    );
  }
}

export default CurrentOccupation;
